import { css } from '@compiled/react';
import PropTypes from 'prop-types';

import type { GlyphProps } from '@atlaskit/icon/types';

import { wacToken } from '@/libraries/design/foundations';

type CloseIconProps = GlyphProps & {
	lightMode?: boolean;
};

export const CloseIcon: React.FC<CloseIconProps> = ({ lightMode = false }) => {
	const strokeColor = lightMode
		? wacToken('color.neutral.light0')
		: wacToken('color.primary.black');

	return (
		<div
			css={css({
				width: '21px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			})}
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="17"
				height="35"
				viewBox="0 0 17 35"
				fill="none"
			>
				<path
					d="M15 26L2.27208 13.2721"
					stroke={strokeColor}
					strokeWidth="3"
					strokeLinecap="round"
				/>
				<path
					d="M2 26L14.7279 13.2721"
					stroke={strokeColor}
					strokeWidth="3"
					strokeLinecap="round"
				/>
			</svg>
		</div>
	);
};

CloseIcon.propTypes = {
	lightMode: PropTypes.bool,
};
